module.exports = require("joi");


/*****************
 ** WEBPACK FOOTER
 ** external "joi"
 ** module id = 29
 ** module chunks = 0
 **/